
export default {
    computed: {
        searchContainer() {
            return this.$store.state.searchContainer;
        }
    }
}
